import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { debounce } from 'lodash';
import { usePaginationAndSort } from '@restore/helpers';
import { useValidationSpecialistSubjectsSlice } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.slice';

export const useSubjectListFilters = () => {
  const { clinicalTrialId } = useParams<{
    clinicalTrialId: string;
  }>();

  const [search, fetchValidationSpecialistSubjectsList, setSearchValue] =
    useValidationSpecialistSubjectsSlice((state, actions) => [
      state.search,
      actions.fetchValidationSpecialistSubjectsList,
      actions.setSearchValue,
    ]);
    
    const { setSortBy, sortBy, currentPage, currentPageSize, setCurrentPage } =
    usePaginationAndSort('validationSpecialistSubjects');
    
    const onSort = (name: string, dir?: string) => {
    const sort = dir ? `${name},${dir}` : undefined;
    setSortBy({ listName: 'validationSpecialistSubjects', newSortBy: sort });
  };
  
  const onSearch = useMemo(
    () =>
      debounce((value: string) => {
        if ((value && value.length > 1) || value === '') {
          setCurrentPage({ listName: 'validationSpecialistSubjects', newPage: 1 });
          setSearchValue(value);
        }
      }, 500),
      [setCurrentPage]
    );

    useEffect(() => {
      if (clinicalTrialId) {
      fetchValidationSpecialistSubjectsList({
        clinicalTrialId,
        args: {
          patientCode: search,
          sort: sortBy,
          page: currentPage,
          size: currentPageSize,
        },
      });
    }
  }, [
    clinicalTrialId,
    search,
    sortBy,
    currentPage,
    currentPageSize,
  ]);

  return {
    onSort,
    onSearch,
    setSortBy,
    sortBy,
    currentPage,
    currentPageSize,
    setCurrentPage,
  };
};
